module.exports = __webpack_public_path__ + "static/media/galleryP.b4346410.jpg";